/* global Swiper */
// *******************************************************************************
// 1.0 - Single Product
// *******************************************************************************

const singleProductSliderElements = document.querySelectorAll('[data-slider="single-product-slider"]');

const singleProductSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 1000,
  watchOverflow: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

singleProductSliderElements.forEach((el) => {
  const parent = el.closest('.single-product');
  const arrowRight = parent.querySelector('.swiper-button-next');
  const arrowLeft = parent.querySelector('.swiper-button-prev');

  singleProductSliderOptions.navigation.nextEl = arrowRight;
  singleProductSliderOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, singleProductSliderOptions);
});
